import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/cpRegistriesListAction";

const initialState = {
	isLoading: true,
	isNoItems: false,
	scroll: {
		isLoading: false,

		size: 20,
		page: 0,
		totalElements: 0
	},
	search: {
		value: "",
		isLoading: false,
		isNoItems: false
	},
	items: []
};
const actionHandlers = {
	// Initialize
	[action.initRegistriesKkmList.request]: createMutateReducer(draft => {
		draft.isLoading = true;
		draft.isNoItems = false;
		draft.items = [];

		draft.scroll.page = 0;
	}),
	[action.initRegistriesKkmList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.isLoading = false;
		draft.isNoItems = items.length === 0;
		draft.items = items;

		draft.scroll.totalElements = totalElements;
	}),
	[action.initRegistriesKkmList.error]: createMutateReducer(draft => {
		draft.isLoading = false;
		draft.isNoItems = true;
	}),

	// Infinite scroll
	[action.scrollRegistriesKkmList.request]: createMutateReducer(draft => {
		draft.scroll.isLoading = true;
	}),
	[action.scrollRegistriesKkmList.success]: createMutateReducer((draft, { items, page }, state) => {
		draft.scroll.isLoading = false;
		draft.scroll.page = page;
		draft.items = [...state.items, ...items];
	}),
	[action.scrollRegistriesKkmList.error]: createMutateReducer(draft => {
		draft.scroll.isLoading = false;
	}),

	// Search
	[action.searchRegistriesKkmList.request]: createMutateReducer((draft, { value }) => {
		draft.search.isLoading = true;
		draft.search.value = value;

		draft.scroll.page = 0;
	}),
	[action.searchRegistriesKkmList.success]: createMutateReducer((draft, { value, items, totalElements }, state) => {
		if (value === state.search.value) {
			draft.search.isLoading = false;
			draft.search.isNoItems = items.length === 0;
			draft.scroll.totalElements = totalElements;
			draft.items = items;
		}
	}),
	[action.searchRegistriesKkmList.error]: createMutateReducer(draft => {
		draft.search.isLoading = false;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
